


import React, { useState, useEffect, useContext } from 'react';
import {
 Dialog,
 DialogTitle,
 DialogContent,
 DialogActions,
 Button,
 TextField,
 Typography,
 List,
 ListItem,
 ListItemText,
 ListItemSecondaryAction,
 IconButton,
 Box,
 Chip,
 Menu,
 MenuItem,
 Alert,
 Divider,
 Select,
 FormControl,
 InputLabel,
} from '@mui/material';
import {
 Save as SaveIcon,
 Delete as DeleteIcon,
 FileCopy as CloneIcon,
 MoreVert as MoreVertIcon,
 Folder as FolderIcon,
 Edit as EditIcon
} from '@mui/icons-material';
import { ReportTemplateService, TemplateProcessor } from '../../services/reportTemplateService';
import { toast } from 'react-toastify';
import { AuthContext } from '../../context/auth-context';
import CloseIcon from '@mui/icons-material/Close';

const ReportTemplateManager = ({
 open,
 onClose,
 selectedOptionShow,
 activeSequence,
 onLoadTemplate,
 user_id,
 onStartEdit,
 initialView = 'list', // 'list', 'save', 'update'
 currentTemplateInfo = null, // Current template info for update mode
 isChecked = false,
 onTemplateDeleted
}) => {
 const [view, setView] = useState('list'); // 'list', 'save', 'load'
 const [templates, setTemplates] = useState([]);
 const [loading, setLoading] = useState(false);
 const [error, setError] = useState(null);
 const { user } = useContext(AuthContext); 
 // const [userId, setUserId] = useState(user?.user_role?.user_id);
 const uid = user?.user_role?.user_id;
 console.log("user", user, "uid", uid);
 // console.log("user", user);


 // Save template state
 const [templateName, setTemplateName] = useState('');
 const [templateDescription, setTemplateDescription] = useState('');

 // Menu state
 const [anchorEl, setAnchorEl] = useState(null);
 const [selectedTemplate, setSelectedTemplate] = useState(null);

 const reportType = selectedOptionShow === 'Product' ? 'product_monitoring' : 'brand_monitoring';
 const [isFormReady, setIsFormReady] = useState(false);

 // useEffect(() => {
 //  if (open && view === 'list' && user_id) {
 //   loadTemplates();
 //  }
 // }, [view, open, user_id, reportType]);

 useEffect(() => {
  if (open) {
   setIsFormReady(false); // Reset when dialog opens
   setView(initialView);

   // Pre-populate fields for update mode
   if (initialView === 'update' && currentTemplateInfo) {
    setTemplateName(currentTemplateInfo.name || '');
    setTemplateDescription(currentTemplateInfo.description || '');
    // ✅ Mark form as ready after a small delay
    setTimeout(() => setIsFormReady(true), 100);
   } else if (initialView === 'save') {
    setTemplateName('');
    setTemplateDescription('');
    setIsFormReady(true);
   } else if (initialView === 'list') {
    setIsFormReady(true);
    loadTemplates();
   }
  }
 }, [open, initialView, currentTemplateInfo]);


 useEffect(() => {
  if (open) {
   setView(initialView);

   // Pre-populate fields for update mode
   if (initialView === 'update' && currentTemplateInfo) {
    setTemplateName(currentTemplateInfo.name || '');
    setTemplateDescription(currentTemplateInfo.description || '');
   } else if (initialView === 'save') {
    // Clear fields for save as new
    setTemplateName('');
    setTemplateDescription('');
   } else if (initialView === 'list') {
    // Load templates when showing list view
    loadTemplates();
   }
  }
 }, [open, initialView, currentTemplateInfo]);

 const resetDialogState = () => {
  setView('list');
  setTemplateName('');
  setTemplateDescription('');
  setError(null);
  setLoading(false);
  setAnchorEl(null);
  setSelectedTemplate(null);
 };

 useEffect(() => {
  if (!open) {
   // Small delay to allow closing animation
   const timer = setTimeout(resetDialogState, 150);
   return () => clearTimeout(timer);
  }
 }, [open]);

 const loadTemplates = async () => {
  try {
   if (!user_id) return;
   setLoading(true);
   setError(null);
   const data = await ReportTemplateService.getTemplates(reportType, user_id);
   setTemplates(data || []);
  } catch (err) {
   setError('Failed to load templates');
   console.error('Template load error:', err);
  } finally {
   setLoading(false);
  }
 };

 const handleEditTemplate = () => {
  if (!selectedTemplate) return;
  if (!selectedTemplate?.can_edit) {
   toast.info('Default templates cannot be edited.');
   handleMenuClose(); // Close menu after showing message
   return;
  }

  // Close menu BEFORE calling onStartEdit
  handleMenuClose();
  onStartEdit && onStartEdit(selectedTemplate);
  onClose(); // close manager so Update button can show on LLMReporting
 };


 // const handleSaveTemplate = async () => {
 //  try {
 //   setLoading(true);
 //   setError(null);

 //   if (!templateName.trim()) {
 //    setError('Template name is required');
 //    return;
 //   }

 //   let savedTemplate;

 //   // Update mode
 //   if (view === 'update' && currentTemplateInfo?.id) {
 //    savedTemplate = await ReportTemplateService.updateTemplate(currentTemplateInfo.id, {
 //     template_name: templateName.trim(),
 //     description: templateDescription.trim() || null,
 //     config_data: activeSequence,
 //     show_change_data: isChecked,
 //     user_id: user_id
 //    });

 //    toast.success(`Template "${templateName}" updated successfully`);
 //   }
 //   // Create mode
 //   else {
 //    savedTemplate = await ReportTemplateService.createTemplate({
 //     template_name: templateName.trim(),
 //     description: templateDescription.trim() || null,
 //     report_type: reportType,
 //     config_data: activeSequence,
 //     show_change_data: isChecked,
 //     user_id: user_id
 //    });

 //    toast.success('Template saved successfully');
 //   }

 //   // ✅ Update parent with the saved template info
 //   const templateInfo = {
 //    id: savedTemplate.id,
 //    name: savedTemplate.template_name,
 //    description: savedTemplate.description,
 //    show_change_data: savedTemplate.show_change_data,
 //    is_system: savedTemplate.is_system || false
 //   };

 //   // Call onLoadTemplate to update parent state with saved config
 //   onLoadTemplate(activeSequence, templateInfo);

 //   resetDialogState();
 //   onClose();
 //  } catch (err) {
 //   const errorMsg = err.message || 'Failed to save template';
 //   setError(errorMsg);
 //   toast.error(errorMsg);
 //  } finally {
 //   setLoading(false);
 //  }
 // };

 const handleSaveTemplate = async () => {
  try {
   setLoading(true);
   setError(null);

   if (!templateName.trim()) {
    setError('Template name is required');
    return;
   }

   let savedTemplate;

   // Update mode
   if (view === 'update' && currentTemplateInfo?.id) {
    savedTemplate = await ReportTemplateService.updateTemplate(currentTemplateInfo.id, {
     template_name: templateName.trim(),
     description: templateDescription.trim() || null,
     config_data: activeSequence,
     show_change_data: isChecked,
     user_id: user_id
    });

    toast.success(`Template "${templateName}" updated successfully`);
   }
   // Create mode
   else {
    savedTemplate = await ReportTemplateService.createTemplate({
     template_name: templateName.trim(),
     description: templateDescription.trim() || null,
     report_type: reportType,
     config_data: activeSequence,
     show_change_data: isChecked,
     user_id: user_id
    });

    toast.success('Template saved successfully');
   }

   // Complete template info with all necessary properties
   const templateInfo = {
    id: savedTemplate.id,
    name: savedTemplate.template_name,
    description: savedTemplate.description,
    show_change_data: savedTemplate.show_change_data,
    user_id: savedTemplate.user_id,
    is_system: savedTemplate.is_system || false,
    can_edit: savedTemplate.can_edit,
    can_delete: savedTemplate.can_delete
   };

   // Call onLoadTemplate to update parent state with saved config
   // This will also clear editingTemplate state in the parent
   onLoadTemplate(activeSequence, templateInfo);

   resetDialogState();
   onClose();
  } catch (err) {
   const errorMsg = err.message || 'Failed to save template';
   setError(errorMsg);
   toast.error(errorMsg);
  } finally {
   setLoading(false);
  }
 };

 // const handleLoadTemplate = async (templateId) => {
 //  try {
 //   setLoading(true);
 //   const { activeSequence: loadedSequence, template } = await TemplateProcessor.loadTemplate(templateId, user_id);

 //   // Find the template info to pass to parent
 //   // const template = templates.find(t => t.id === templateId);
 //   const templateInfo = {
 //    id: templateId,
 //    name: template?.template_name || template?.name || `Template #${templateId}`,
 //    show_change_data: template?.show_change_data || false,
 //    is_system: template?.is_system || false
 //   };

 //   // Pass both sequence and template info to parent
 //   onLoadTemplate(loadedSequence, templateInfo);
 //   // toast.success('Template loaded successfully');
 //   resetDialogState();
 //   onClose();
 //  } catch (err) {
 //   toast.error('Failed to load template');
 //   console.log(err);
 //  } finally {
 //   setLoading(false);
 //  }
 // };


 const handleLoadTemplate = async (templateId) => {
  try {
   setLoading(true);
   const { activeSequence: loadedSequence, template } = await TemplateProcessor.loadTemplate(templateId, user_id);

   // ✅ Complete template info
   const templateInfo = {
    id: templateId,
    name: template?.template_name || template?.name || `Template #${templateId}`,
    description: template?.description,
    show_change_data: template?.show_change_data || false,
    user_id: template?.user_id,
    is_system: template?.is_system || false,
    can_edit: template?.can_edit,
    can_delete: template?.can_delete
   };

   onLoadTemplate(loadedSequence, templateInfo);
   resetDialogState();
   onClose();
  } catch (err) {
   toast.error('Failed to load template');
   console.log(err);
  } finally {
   setLoading(false);
  }
 };
 

 const handleDeleteTemplate = async (templateId) => {
  handleMenuClose();
  try {
   setLoading(true);
   await ReportTemplateService.deleteTemplate(templateId, user_id);
   toast.success('Template deleted successfully');
   if (onTemplateDeleted) {
    onTemplateDeleted(templateId);
   }
   loadTemplates();
  } catch (err) {
   const errorMsg = err.message || 'Failed to delete template';
   toast.error(errorMsg);
  } finally {
   setLoading(false);
  }
 };

 const getDialogTitle = () => {
  switch (view) {
   case 'update':
    return 'Update Template With Current Configuration';
   case 'save':
    return 'Save Template With Current Configuration';
   default:
    return 'Template Manager';
  }
 };

 const handleCloneTemplate = async (templateId) => {
  const template = templates.find(t => t.id === templateId);
  if (!template) return;

  const newName = prompt('Enter name for cloned template:', `${template.template_name} (Copy)`);
  if (!newName) return;

  try {
   setLoading(true);
   await ReportTemplateService.cloneTemplate(templateId, newName);
   toast.success('Template cloned successfully');
   loadTemplates();
  } catch (err) {
   toast.error('Failed to clone template');
  } finally {
   setLoading(false);
   handleMenuClose();
  }
 };

 const handleMenuOpen = (event, template) => {
  setAnchorEl(event.currentTarget);
  setSelectedTemplate(template);
 };

 const handleMenuClose = () => {
  setAnchorEl(null);
  setSelectedTemplate(null);
 };

 const renderTemplateList = () => (
  <Box>
   <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, mt: 2 }}>
    <Typography variant="h6">
     {reportType.charAt(0).toUpperCase() + reportType.slice(1)} Templates
    </Typography>
    <Button
     variant="contained"
     startIcon={<SaveIcon />}
     onClick={() => setView('save')}
     size="small"
    >
     Save Current
    </Button>
   </Box>

   {loading ? (
    <Typography>Loading templates...</Typography>
   ) : templates.length === 0 ? (
    <Box sx={{ textAlign: 'center', py: 3 }}>
     <FolderIcon sx={{ fontSize: 48, color: 'grey.400', mb: 1 }} />
     <Typography color="textSecondary">
      No templates found for {reportType} reports
     </Typography>
     <Button
      variant="outlined"
      onClick={() => setView('save')}
      sx={{ mt: 1 }}
     >
      Create Your First Template
     </Button>
    </Box>
   ) : (

      <List>
       {templates.map((template, index) => (
        <React.Fragment key={template.id}>
         <ListItem
          divider={false} // Remove default divider
          sx={{
           display: 'flex',
           alignItems: 'flex-start',
           py: 1.5
          }}
         >
          <Box sx={{ flex: 1, minWidth: 0 }}>
           <Typography
            variant="subtitle1"
            sx={{ fontWeight: 600, mb: 0.5 }}
           >
            {template.template_name}
           </Typography>
           <Typography variant="body2" color="textSecondary" sx={{ mb: 0.5 }}>
            {template.description || 'No description'}
           </Typography>
           <Typography variant="caption" color="textSecondary">
            {new Date(template.created_at).toLocaleDateString()}
           </Typography>
          </Box>

          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', ml: 2 }}>
           <Button
            size="small"
            variant="outlined"
            onClick={() => handleLoadTemplate(template.id)}
           >
            Load
           </Button>
           <IconButton
            onClick={(e) => handleMenuOpen(e, template)}
            size="small"
           >
            <MoreVertIcon />
           </IconButton>
          </Box>
         </ListItem>

         {/* Add Divider after each item except the last */}
         {index < templates.length - 1 && <Divider />}
        </React.Fragment>
       ))}
      </List>
   )}
  </Box>
 );

 const getDetailedSummary = () => {
  if (!Array.isArray(activeSequence)) return 'Invalid configuration';

  const sectionSummaries = activeSequence.map(section => {
   const totalItems = section.config ? section.config.length : 0;
   const activeItems = section.config ? section.config.filter(item => item.is_active).length : 0;
   return `${section.label}: ${activeItems}/${totalItems}`;
  }).join(', ');

  const totalActive = activeSequence.reduce((total, section) =>
   total + (section.config ? section.config.filter(item => item.is_active).length : 0), 0
  );

  return { sectionSummaries, totalActive };
 };


 const renderSaveTemplate = () => (
  <Box>

   <Box sx={{ mb: 2, mt: 2 }}>
    <Chip
     label={`Report Type: ${reportType.charAt(0).toUpperCase() + reportType.slice(1)}`}
     color="primary"
     size="small"
     sx={{ mb: 1 }}
    />
   </Box>

   <TextField
    fullWidth
    label="Template Name"
    value={templateName}
    onChange={(e) => setTemplateName(e.target.value)}
    sx={{ mb: 2 }}
    required
   />

   <TextField
    fullWidth
    label="Description (Optional)"
    value={templateDescription}
    onChange={(e) => setTemplateDescription(e.target.value)}
    multiline
    rows={3}
    sx={{ mb: 2 }}
   />

   <Box sx={{ display: 'flex', gap: 1 }}>
    <Button
     variant="outlined"
     onClick={() => {
      setView('list');
      setTemplateName('');
      setTemplateDescription('');
     }}
    >
     Back
    </Button>
    {/* <Button
     variant="contained"
     onClick={handleSaveTemplate}
     disabled={!templateName.trim() || loading}
     startIcon={<SaveIcon />}
    >
     {view === 'update' ? 'Update' : 'Save'}
    </Button> */}
    <Button
     variant="contained"
     onClick={handleSaveTemplate}
     disabled={!templateName.trim() || loading || !isFormReady}
     startIcon={<SaveIcon />}
    >
     {view === 'update' ? 'Update' : 'Save'}
    </Button>
   </Box>
  </Box>
 );

 return (
  <>
   <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
    fullWidth
    PaperProps={{
     sx: { minHeight: 400 }
    }}
   >
    <DialogTitle sx={{
     borderBottom: '1px solid #e0e0e0',
     display: 'flex',
     justifyContent: 'space-between',
     alignItems: 'center',
     pr: 1
    }}>
     {getDialogTitle()}
     <IconButton
      onClick={onClose}
      size="small"
      sx={{ ml: 2 }}
     >
      <CloseIcon />
     </IconButton>
    </DialogTitle>

    <DialogContent>
     {error && (
      <Alert severity="error" sx={{ mb: 2 }}>
       {error}
      </Alert>
     )}

     {view === 'list' && renderTemplateList()}
     {(view === 'save' || view === 'update') && renderSaveTemplate()}
    </DialogContent>

    {/* Remove DialogActions completely */}
   </Dialog>

   {/* Context Menu */}
   <Menu
    anchorEl={anchorEl}
    open={Boolean(anchorEl)}
    onClose={handleMenuClose}
   >
    {/* <MenuItem onClick={() => handleLoadTemplate(selectedTemplate?.id)}>
     Load Template
    </MenuItem> */}
    {/* <MenuItem onClick={() => handleCloneTemplate(selectedTemplate?.id)}>
     <CloneIcon fontSize="small" sx={{ mr: 1 }} />
     Clone
    </MenuItem> */}
    <MenuItem onClick={handleEditTemplate} disabled={!selectedTemplate?.can_edit}>
       <EditIcon fontSize="small" sx={{ mr: 1 }} />
       Edit
     </MenuItem>
    <Divider />
    <MenuItem
     onClick={() => handleDeleteTemplate(selectedTemplate?.id)}
     sx={{ color: 'error.main' }}
     disabled={!selectedTemplate?.can_delete}
    >
     <DeleteIcon fontSize="small" sx={{ mr: 1 }} />
     Delete
    </MenuItem>
   </Menu>
  </>
 );
};

export default ReportTemplateManager;